import { db } from '../config/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { httpsCallable, getFunctions } from 'firebase/functions';

// Collection name
const SYNC_STATUS_COLLECTION = 'pmt2_sync_status';

/**
 * Fetches the latest sync status document.
 * @returns The latest sync status data object or null if not found.
 */
export const getSyncStatus = async (): Promise<any | null> => {
  const docRef = doc(db, SYNC_STATUS_COLLECTION, 'latest');
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  }

  console.warn('No sync status document found.');
  return null;
};

/**
 * Triggers the manual sync Firebase Function.
 * @throws Error if the function call fails.
 */
export const triggerManualSync = async (): Promise<void> => {
  try {
    const functions = getFunctions(); // Use default region
    const triggerSync = httpsCallable(functions, 'triggerPMT2Sync');
    console.log('Triggering manual sync function...');
    const result = await triggerSync();
    console.log('Manual sync function triggered successfully:', result.data);
  } catch (error) {
    console.error('Error triggering manual sync function:', error);
    throw new Error('Failed to trigger manual sync.');
  }
};